<template>
  <div class="workList">
    <div class="topButtDiv">
      <div style='display:inline-block; margin-left: 10px' v-if="isConnect">
        <Input search enter-button="查询" icon="ios-search" size='default' v-model="keyword" placeholder="请在此输入关键字" style="width: 450px" class='topSearch' @on-click='searchFn' @on-search='searchFn' clearable>
            <span slot="append" class="rightButt" @click='searchFn'>
              <Icon type="ios-search" class="rightIcon"/>
              查询
            </span>
        </Input>
      </div>
<!--      <Button type="primary" @click="orgInfo" class="clickBut">查看报名单位信息</Button>-->
    </div>
    <section v-if="isConnect" class="sectionDiv">
      <Table size='default' class='activeList' ref="selection" border :loading='isLoading' highlight-row :columns="columns" :data="data" :max-height="tableHeight"></Table>
      <Page :total="totalCount" :current='currPage' :page-size="pageSize" :page-size-opts='pageSizeOpts' show-sizer show-elevator show-total transfer @on-change="pageChange" @on-page-size-change="pageSizeChange" :max-height="tableHeight"/>
      <div class="butText">作品推荐截止时间：{{new Date().getFullYear()}}年8月10日，在此之前可更换推荐作品。推荐时间结束后不可再更换推荐作品。</div>
    </section>
    <section v-else class="sectionDiv">
      <div class="tips">
        <img :src="noConnectImg" alt="">
        <span>机构尚未关联活动平台，请联系管理员</span>
      </div>
    </section>
<!--    <orgInfoModal :is-info-modal.sync="isInfoModal" v-if="isInfoModal"></orgInfoModal>-->
    <sourceModal ref='sourceModal' :controlSourceModal='this.sourceModal' :sourceType='sourceType' :sourceCovor='sourceCovor' @changeCover='changeCover'></sourceModal>
    <Modal title="封面缩略图" :value="isImageShow" @on-visible-change="showChange" footer-hide>
      <div :style="{backgroundImage: 'url(' + this.fileUrl + ')',  backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    width: '500px',
    height: '500px',
    margin: '0 auto'}"></div>
    </Modal>
  </div>
</template>

<script>
import {
  handleResAuthor,
  backMessage,
  handleRes,
  confirm,
  getUrlCode,
  backendTokenRemove,
  RECEND,
  getCookie
} from '@/js/public'
import { Icon, Button, Tooltip, Table, Page, Input } from 'view-design'
import { mapState } from 'vuex'
import { orgGetWorkList, getOrgInfo, workCancelRec, workRec, getUserInfo, getSuperUser } from '@/api/getApi'
// import orgInfoModal from '@/components/admin/workList/orgInfoModal'
import noConnectImg from '@/assets/images/u536.png'
import { caseInfo } from '@/components/admin/caseList/info'
import sourceModal from '@/components/common/sourceModal'
export default {
  name: 'workList',
  components: { Table, Page, Input, sourceModal },
  data () {
    return {
      msg: caseInfo,
      noConnectImg: noConnectImg,
      isLoading: false,
      currPage: 1,
      totalCount: 0,
      keyword: '',
      isConnect: true,
      isInfoModal: false,
      sourceType: '',
      sourceCovor: '',
      orgInfoObj: {},
      data: [],
      pageSizeOpts: [10, 20, 50, 100],
      pageSize: 10,
      columns: [
        {
          title: '序号',
          type: 'index',
          width: 40,
          align: 'center'
        },
        {
          title: caseInfo.create_id,
          key: 'create_id',
          align: 'center',
          minWidth: 90,
          render: (h, params) => {
            return <div domPropsInnerHTML={this.data[params.index].number}></div>
          }
        },
        {
          title: caseInfo.title,
          key: 'title',
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            return <div domPropsInnerHTML={this.data[params.index].title}>
            </div>
          }
        },
        {
          title: caseInfo.path,
          key: 'path',
          align: 'center',
          minWidth: 80,
          render: (h, params) => {
            return <div>
              <div
                style={{ display: 'inline-block', width: '25px', height: '25px', fontSize: '25px', cursor: 'pointer' }}
                onClick={() => this.showSource(params.index)}>
                {
                  this.data[params.index].path
                    ? <Icon type="md-play" style={{ verticalAlign: 'top' }}/>
                    : ''
                }
              </div>
            </div>
          }
        },
        {
          title: '真实姓名',
          key: 'author',
          align: 'center',
          minWidth: 80,
          render: (h, params) => {
            return <div>
              {
                this.data[params.index].user_general_info && this.data[params.index].user_general_info.real_name
                  ? <div>{this.data[params.index].user_general_info.real_name}</div>
                  : ''
              }
            </div>
          }
        },
        {
          title: caseInfo.mobile,
          key: 'mobile',
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            return <div domPropsInnerHTML={this.data[params.index].author_mobile}>
              <div></div>
            </div>
          }
        },
        {
          title: '封面缩略图',
          key: 'cover',
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            return <div >
              {
                this.data[params.index].creation && this.data[params.index].creation.cover_url
                  ? <div style={{ margin: '2px auto', width: '50px', height: '50px', backgroundImage: 'url(' + this.data[params.index].creation.cover_url + ')', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', backgroundSize: 'contain', cursor: 'pointer' }} onClick={() => this.showImage(this.data[params.index].creation.cover_url)}>
                  </div>
                  : ''
              }
            </div>
          }
        },
        {
          title: caseInfo.profile,
          key: 'profile',
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            return <div style={{ maxHeight: '105px' }}>
              <Tooltip placement="left" theme="light" max-width="680" style={{ overflow: 'hidden' }} transfer>
                <div domPropsInnerHTML={this.data[params.index].profileText} style={{ textAlign: 'left', maxHeight: '105px', minWidth: '100px', minHight: '21px' }} class={{ ellipsis: true }}></div>
                <div slot="content" domPropsInnerHTML={this.data[params.index].profile}>
                </div>
              </Tooltip>
            </div>
          }
        },
        {
          title: '身份类别',
          minWidth: 100,
          align: 'center',
          render: (h, params) => {
            return <div>{
              this.idArr.map(i => {
                if (this.data[params.index].org_user.identity == i.id) {
                  return <div>{i.name}</div>
                }
              })
            }</div>
          }
        },
        {
          title: '院系',
          minWidth: 100,
          align: 'center',
          render: (h, params) => {
            return <div>{this.data[params.index].org_user ? this.data[params.index].org_user.department : ''}</div>
          }
        },
        {
          title: '学号',
          minWidth: 100,
          align: 'center',
          render: (h, params) => {
            return <div>{this.data[params.index].org_user ? this.data[params.index].org_user.academic_num : ''}</div>
          }
        },
        {
          title: '院系名称',
          minWidth: 100,
          align: 'center',
          render: (h, params) => {
            return <div>{this.data[params.index].user_general_info ? this.data[params.index].user_general_info.department : ''}</div>
          }
        },
        {
          title: '指导老师',
          minWidth: 100,
          align: 'center',
          render: (h, params) => {
            return <div>{this.data[params.index].user_general_info ? this.data[params.index].user_general_info.instructor : ''}</div>
          }
        },
        {
          title: '操作',
          minWidth: 150,
          align: 'center',
          key: 'is_rec',
          render: (h, params) => {
            return <div>
              <Button
                size='default'
                icon={this.data[params.index].is_rec ? 'md-heart-outline' : 'md-heart'}
                type={this.data[params.index].is_rec ? 'warning' : 'info'}
                nativeOnClick={() => this.recommend(params.index)}
                disabled={!RECEND}>
                <span domPropsInnerHTML={this.data[params.index].is_rec ? this.msg.cancelRecommend : this.msg.recommend}></span>
              </Button>
            </div>
          }
        }
      ],
      selfId: '',
      idArr: [
        {
          id: 1,
          name: '研究生'
        },
        {
          id: 2,
          name: '本科生'
        },
        {
          id: 3,
          name: '高职生'
        },
        {
          id: 4,
          name: '国防生'
        },
        {
          id: 5,
          name: '留学生'
        },
        {
          id: 6,
          name: '委培生'
        },
        {
          id: 7,
          name: '教职工'
        },
        {
          id: 8,
          name: 'MBA'
        },
        {
          id: 9,
          name: '外来培训'
        },
        {
          id: 10,
          name: '进修生'
        },
        {
          id: 11,
          name: '校友毕业生'
        },
        {
          id: 12,
          name: '预科生'
        },
        {
          id: 13,
          name: '体训生'
        },
        {
          id: 14,
          name: '专升本'
        }
      ],
      fileUrl: '',
      isImageShow: false
    }
  },
  computed: {
    orgID: () => getUrlCode('orgID'),
    ...mapState({
      sourceModal: state => state.sourceModal,
      tableHeight: state => state.tableHeight
    }),
    isCommon () {
      return getCookie('level') == 0
    },
    realOrgId () {
      const queryData = this.$route.query
      return queryData && Object.keys(queryData).length && queryData.org_id ? queryData.org_id : this.selfId
    }
  },
  methods: {
    searchFn () {
      this.currPage = 1
      this.getOrgList()
    },
    pageChange (data) {
      this.currPage = data
      this.getOrgList()
    },
    showImage (url) {
      this.fileUrl = url
      this.isImageShow = true
    },
    showChange (v) {
      this.isImageShow = v
    },
    // 页面条数变化
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      if (this.currPage === 1) {
        this.getOrgList()
      }
    },
    showSource (index) {
      this.sourceCovor = this.data[index].path
      this.sourceType = '2'
      const that = this
      const refTarget = this.$refs.sourceModal
      setTimeout(() => {
        refTarget.changeSouce(that.sourceType, `${that.data[index].path}`)
      })
      this.$store.dispatch('sourceModal', true)
    },
    async recommend (index) {
      const flag = this.data[index].is_rec
      const message = flag ? '是否取消推荐当前作品？' : '是否推荐当前作品？'
      await confirm('提示', message, async () => {
        if (flag) {
          const res = await workCancelRec(this.realOrgId, this.data[index].cid)
          handleRes(res, '操作成功', () => {
            this.data[index].is_rec = !this.data[index].is_rec
            this.getOrgList()
          }, res.message)
        } else {
          const res = await workRec(this.realOrgId, this.data[index].cid)
          handleRes(res, '操作成功', () => {
            this.data[index].is_rec = !this.data[index].is_rec
            this.getOrgList()
          }, res.message)
        }
      })
    },
    formatData (data) {
      const selfData = []
      data.forEach((val, ind) => {
        val.profileText = val.profile.replace(/<img[^>]+>/g, '[图片]').replace(/<[^>]+>/g, '')
        selfData.push(val)
      })
      this.data = selfData
    },
    async getOrgList () {
      this.isLoading = true
      const queryData = this.$route.query
      const params = {
        page: queryData?.currPage ?? this.currPage,
        keyword: queryData?.keyword ?? this.keyword,
        page_size: queryData?.pageSize ?? this.pageSize
      }
      const res = await orgGetWorkList(this.realOrgId, params)
      handleResAuthor(res.code, res.message)
      handleRes(res, '', () => {
        this.keyword = queryData?.keyword ?? this.keyword
        this.totalCount = res.data?.total ?? 1
        this.currPage = res.data?.['current_page'] ?? 1
        this.pageSize = Number(res.data?.['per_page'])
        this.formatData(res.data.data)
      }, '获取作品列表失败，请稍候再试')
      this.isLoading = false
    },
    // async orgInfo () {
    //   this.isInfoModal = true
    // },
    // 控制刷新资源的方法
    changeCover () {
      this.sourceCovor = ''
      this.sourceType = '0'
      this.$store.dispatch('sourceType', this.sourceType)
      this.childControlShow('0', this.sourceCovor)
    },
    // 子组件需调用资源组件时，更改资源类型方法
    childControlShow (type, url) {
      // this.isShowSourceModal = true
      this.sourceType = `${type}`
      if (this.sourceType === '1') {
        this.sourceCovor = url
      } else if (this.sourceType === '3') {
        // 音频信息通过VUEX传输
        this.$store.dispatch('myMusicInfo', {
          title: '音频',
          artist: '管理员',
          src: url,
          pic: ''
        })
        this.sourceCovor = url
        this.$refs.sourceModal.changeSouce(this.sourceType, `${url}`)
      } else {
        this.sourceCovor = url
        this.$refs.sourceModal.changeSouce(this.sourceType, `${url}`)
      }
      this.$store.dispatch('sourceModal', true)
    },
    async getOrgInfo () {
      const res = await getOrgInfo(this.$route.query.orgID)
      handleResAuthor(res, '')
      handleRes(res, '', () => {
        const d = res.data
        this.orgInfoObj = {
          name: d.university,
          principal: d.name,
          department: d.department,
          position: d.position,
          mobile: d.mobile,
          telephone: d.telephone
        }
        this.isConnect = res.data.reader_act_id !== 0
      }, '', () => {
        if (res.code === 401) {
          backMessage('', '登录token已过期，请重新登录')
          backendTokenRemove()
          return false
        } else {
          backMessage('', '获取机构信息失败，请稍候再试')
        }
      })
    },
    async getConnect () {
      const res = await getUserInfo()
      handleResAuthor(res.code, res.message)
      this.isConnect = !!(res.data && res.data.reader_act_id !== 0)
    },
    async getUserInfomation () {
      const res = await getUserInfo()
      handleResAuthor(res.code, res.message)
      handleRes(res, '', () => {
        this.isConnect = !!(res.data && res.data.reader_act_id !== 0)
        this.selfId = res.data.org_id
      }, '', () => {
        this.$Message.error(res.message)
      })
    },
    async getSuperInfo () {
      const res = await getSuperUser(this.$route.query.id)
      handleResAuthor(res.code, res.message)
      if (res.code !== 200) {
        this.$Message.error(res.message)
        return false
      }
      this.isConnect = (res.data && res.data.length) ? res.data[0].reader_act_id !== 0 : ''
    }
  },
  async created () {
    this.isCommon ? await this.getUserInfomation() : await this.getSuperInfo()
    await this.getOrgList()
  }
}
</script>

<style lang = 'scss' scoped>
@import "../../assets/scss/public";
.workList {
  height: 100%;
  overflow-y: hidden;
  .sectionDiv {
    position: relative;
    min-height: calc(100% - 38px);
    border-bottom: 1px solid transparent;
    .tips{
      $H: 300px;
      width: 800px;
      height: $H;
      line-height: $H;
      font-size: 28px;
      @include allcenter();
      img{
        width: $H;
        height: $H;
      }
    }
    .butText{
      font-size: 14px;
      margin-top: 15px;
      margin-bottom: 10px;
      line-height: 28px;
      font-weight: bold;
      text-align: center;
    }
  }
  .clickBut{
    margin-left: 10px;
    vertical-align: top;
  }
  .topButtDiv {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .placeholder {
    height: 60%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      margin-bottom: 20px;
    }
  }
  .backImage {
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    width: 500px;
    height: 500px;
    margin: 0 auto;
  }
}
</style>
